import { useEffect } from "react";

const useClarity = () => {
  const projectId = "qq29mqi5m5";

  const setUserIdClarity = (brandId) => {
    try {
      if (window.clarity) {
        const id = brandId != null ? String(brandId) : "";
        window.clarity("set", "userId", id);
      }
    } catch (error) {
      console.error("Failed to set Clarity userId:", error);
    }
  };

  useEffect(() => {
    if (projectId) {
      try {
        (function (c, l, a, r, i, t, y) {
          c[a] =
            c[a] ||
            function () {
              (c[a].q = c[a].q || []).push(arguments);
            };
          t = l.createElement(r);
          t.async = 1;
          t.src = "https://www.clarity.ms/tag/" + i;
          y = l.getElementsByTagName(r)[0];
          y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", projectId);
      } catch (error) {
        console.log(error);
      }
    }
  }, []);
  return {
    setUserIdClarity,
  };
};

export default useClarity;
